<template>
    <div id="navcircles" class="z-index-1000">
        <ul>
            <li v-for="menuitem in $root.menuitems">
                <div :class="['navcircles', {'active': menuitem.name == $route.name}]" @click="changeRoute(menuitem.name)"></div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'navcircles',

    methods: {
        changeRoute(newRoute) {
            this.$root.setTransitionRouterView(newRoute);
            this.$router.push({name: newRoute});
            this.$root.changeRouteView();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/navcircles.vue